import { Box, Button } from '@mui/material';
import {
  PhotoCamera,
  Egg,
  Event as EventIcon,
  Add as AddIcon
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { selectUserDisplayName } from '../../../store/slices/userSlice';

import { useUpdateEntryMutation } from '../../../hooks/useFirebaseQueries';

const QuickActionsBar = ({ entry, onEggRecord, onEventAdd, onWeightAdd }) => {
  const userDisplayName = useSelector(selectUserDisplayName);
    const updateEntryMutation = useUpdateEntryMutation()
  // Determine if this is a female bird (for egg tracking)
  const isFemale = entry.sex?.toLowerCase() === 'female';

  const handlePhotoUploadClick = (e) => {
    e.stopPropagation();

    const fileInput = document.getElementById(`photo-upload-${entry.entryId}`);
    if (fileInput) {
      fileInput.click();
    }
  };

  const handleEggRecord = async (e) => {
    e.stopPropagation();

    try {
      const today = new Date().toISOString().split('T')[0];
      const eggEntry = {
        date: today,
        timestamp: new Date(),
        recordedBy: userDisplayName || 'Unknown'
      };

      // Add new egg to existing egg records
      const currentEggs = entry?.eggs || [];
      const updatedEggs = [...currentEggs, eggEntry];

      // Update the entry in Firebase
      await updateEntryMutation.mutateAsync({
        entryId: entry.entryId,
        entryData: {
          ...entry,
          eggs: updatedEggs
        },
        userDisplayName: userDisplayName
      
      });

      console.log('Egg recorded successfully');
    } catch (error) {
      console.error('Error recording egg:', error);
    }
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: isFemale ? 'repeat(4, 1fr)' : 'repeat(3, 1fr)',
        gap: 0.5,
        mt: 2
      }}
    >
      {/* Photo upload button */}
      <Button
        onClick={handlePhotoUploadClick}
        startIcon={<PhotoCamera />}
        variant="outlined"
        color="secondary"
        size="small"
        sx={{
          borderRadius: 2,
          py: 0.8,
          fontSize: '0.7rem',
          fontWeight: 500,
          textTransform: 'none',
          minWidth: 0,
          '& .MuiButton-startIcon': { marginRight: 0.5 },
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: 2
          },
          transition: 'all 0.2s ease'
        }}
      >
        Photo
      </Button>

      {/* Egg button - only for females */}
      {isFemale && (
        <Button
          onClick={handleEggRecord}
          startIcon={<Egg />}
          variant="outlined"
          color="warning"
          size="small"
          sx={{
            borderRadius: 2,
            py: 0.8,
            fontSize: '0.7rem',
            fontWeight: 500,
            textTransform: 'none',
            minWidth: 0,
            '& .MuiButton-startIcon': { marginRight: 0.5 },
            '&:hover': {
              transform: 'translateY(-1px)',
              boxShadow: 2
            },
            transition: 'all 0.2s ease'
          }}
        >
          Egg
        </Button>
      )}

      {/* Event button */}
      <Button
        onClick={onEventAdd}
        startIcon={<EventIcon />}
        variant="outlined"
        color="info"
        size="small"
        sx={{
          borderRadius: 2,
          py: 0.8,
          fontSize: '0.7rem',
          fontWeight: 500,
          textTransform: 'none',
          minWidth: 0,
          '& .MuiButton-startIcon': { marginRight: 0.5 },
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: 2
          },
          transition: 'all 0.2s ease'
        }}
      >
        Event
      </Button>

      {/* Weight add button */}
      <Button
        onClick={onWeightAdd}
        startIcon={<AddIcon />}
        variant="contained"
        color="primary"
        size="small"
        sx={{
          borderRadius: 2,
          py: 0.8,
          fontSize: '0.7rem',
          fontWeight: 500,
          textTransform: 'none',
          minWidth: 0,
          '& .MuiButton-startIcon': { marginRight: 0.5 },
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: 4
          },
          transition: 'all 0.2s ease'
        }}
      >
        Weight
      </Button>
    </Box>
  );
};

export default QuickActionsBar;
